<template>
    <div class="flex flex-row gap-4 items-center justify-center h-screen">
        <div class="flex flex-col gap-4 items-center">
            <img alt="Company logo" height="80" width="300"
                src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634105033/carrygoWebAssets/carrygo_logo_vrdtw8.svg" />
            <AccountDeletionForm />
        </div>
        <div class="flex flex-col gap-4">
            <img alt="Company logo" height="500" width="256"
                src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634104976/carrygoWebAssets/Rectangle-phone_2_mj2pxb.png" />
            <p class="w-64 text-sm text-center">
                Alternatively, you can delete your account directly inside the app
                via Settings &rarr; "Delete My Account"
            </p>
        </div>
    </div>
</template>

<script>
import AccountDeletionForm from './AccountDeletionForm.vue';

export default {
    name: 'DeleteAccount',
    components: {
        AccountDeletionForm,
    },
    mounted() {
        document.title = 'CarryGo Account Support';
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
            metaDesc.setAttribute('content', 'Account deletion request process for the CarryGo app.');
        } else {
            const meta = document.createElement('meta');
            meta.setAttribute('name', 'description');
            meta.setAttribute('content', 'Account deletion request process for the CarryGo app.');
            document.head.appendChild(meta);
        }
    },
};
</script>
